export const NAV_LIST = [
  {
    id: 1,
    title: 'running',
    list: [
      {
        id: 1,
        name: '신발',
        path: '/products?mainCategory=shoes&subCategory=running',
      },
      {
        id: 2,
        name: '의류',
        path: '/products?mainCategory=clothes&subCategory=running',
      },
      {
        id: 3,
        name: '모자&용품',
        path: '/products?mainCategory=accessories&subCategory=running',
      },
      {
        id: 4,
        name: '전체보기',
        path: '/products?subCategory=running',
      },
    ],
  },
  {
    id: 2,
    title: 'Soccer',
    list: [
      {
        id: 5,
        name: '축구화',
        path: '/products?mainCategory=shoes&subCategory=soccer',
      },
      {
        id: 6,
        name: '의류',
        path: '/products?mainCategory=clothes&subCategory=soccer',
      },
      {
        id: 7,
        name: '팀 컬렉션',
        path: '/products?mainCategory=teamcollection&subCategory=soccer',
      },
      {
        id: 8,
        name: '전체보기',
        path: '/products?subCategory=soccer',
      },
    ],
  },
  {
    id: 3,
    title: 'Basketball',
    list: [
      {
        id: 9,
        name: '신발',
        path: '/products?mainCategory=shoes&subCategory=basketball',
      },
      {
        id: 10,
        name: '의류',
        path: '/products?mainCategory=clothes&subCategory=basketball',
      },
      {
        id: 11,
        name: 'NBA',
        path: '/products?mainCategory=teamcollection&subCategory=basketball',
      },
      {
        id: 12,
        name: '용품',
        path: '/products?mainCategory=accessories&subCategory=basketball',
      },
      {
        id: 13,
        name: '전체보기',
        path: '/products?subCategory=basketball',
      },
    ],
  },
];
